import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from 'react';
import '../../css/machines/MachinePageHeader.css';

const DashboardPageHeader = () => {

    const { t } = useTranslation();

    return (
        <Box className='machine_headre_main_container'>
            <Box className='machine_headre_title_box'>
                <Typography className='machine_headre_page_title'>{t("sideBar-Finance-Dashboard")}</Typography>
            </Box>
        </Box>

    );
};

export default React.memo(DashboardPageHeader);